import script from "./setDistribution.vue?vue&type=script&setup=true&lang=js"
export * from "./setDistribution.vue?vue&type=script&setup=true&lang=js"

import "./setDistribution.vue?vue&type=style&index=0&id=0988efb9&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0988efb9"]])

export default __exports__